
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import CollapseTruncateWrapper from '~/components/snippets/CollapseTruncateWrapper.vue'
import CollapseToggle from '~/components/snippets/CollapseToggle.vue'
import SeoContent from '~/components/SeoContent/SeoContent.vue'

@Component({
  components: {
    SeoContent,
    CollapseTruncateWrapper,
    CollapseToggle,
  },
})
export default class ProviderContentArticle extends Vue {
  @Prop({ required: true, default: () => ({}), type: Object })
  readonly article!: any

  get isCollapsible () {
    return this.article.is_collapsible
  }

  get isExpandedByDefault () {
    return this.article.is_expanded_by_default
  }
}
